import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, NavigationExtras } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { SharedService } from 'src/app/services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private store: Store, private router: Router, private sharedService: SharedService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.sharedService.isBrowser) { return true; }
    const user = this.store.selectSnapshot(state => state.auth.user);
    const checker = new Promise<boolean>(resolve => resolve(!!user));
    checker.then(checked => {
      let loginUrl = next.data.loginUrl || '/login';
      let options: NavigationExtras = {};
      let roles = next.data.role?.split(',').map(_ => _.split(':'));
      if (state.url) options['rb'] = state.url;
      if (next.data.loginType) options['t'] = next.data.loginType;
      if (!checked) { this.router.navigate([loginUrl, options]); }
      if (roles?.length && (!user ||
        !roles.some(_ => user[_[0]] && (!_[1] || user.AccessRights?.includes(_[1])))
      )) { this.router.navigate([loginUrl, options]); }
    });
    return checker;
  }
}
